/**
 * StworzFinish — dokończenie publikacji strony PO zalogowaniu istniejącego usera.
 * Ścieżka: /stworz/dokoncz. Wejście tu następuje z Login (?redirect=/stworz/dokoncz)
 * gdy soft-signup zwrócił 409 (konto z hasłem już istnieje). Odczytuje zapisany draft
 * z localStorage i tworzy realną stronę, po czym przenosi na nią usera.
 */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { provisionFromDraft } from '@/utils/provisionPage';

export default function StworzFinish() {
  const navigate = useNavigate();
  const ran = useRef(false);
  const [msg, setMsg] = useState('Publikuję Twoją stronę…');

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      const token = localStorage.getItem('token');
      if (!token) { navigate('/logowanie?redirect=/stworz/dokoncz'); return; }
      let draft = null;
      try { draft = JSON.parse(localStorage.getItem('apis_page_draft') || 'null'); } catch (e) { /* ignore */ }
      if (!draft || !draft.type) { navigate('/panel'); return; }
      try {
        const path = await provisionFromDraft(draft, token);
        localStorage.removeItem('apis_page_draft');
        localStorage.removeItem('apis_creator_state');
        toast.success('Twoja strona jest online! 🎉');
        window.location.href = path;
      } catch (e) {
        setMsg('Nie udało się opublikować. Przechodzę do panelu…');
        setTimeout(() => navigate('/panel'), 1500);
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0b1620] text-white flex flex-col items-center justify-center gap-4" data-testid="stworz-finish">
      <Loader2 className="w-8 h-8 animate-spin" style={{ color: '#F97316' }} />
      <p className="text-sm text-slate-300">{msg}</p>
    </div>
  );
}
